export default __webpack_public_path__ + "static/media/juego3_ganar.7df4b1c1.png";